import axios from "axios";
import configuration from "../configuration/configuration";

/**
 * Passerelle SMS : historique, renvoi, modèles, aperçu et envoi (routes /api/sms de l'API).
 * Les erreurs sont renvoyées telles quelles : le message du serveur est dans error.response.data.message.
 */
export default class SmsAPI {

    async request(method, url, data) {
        const response = await axios({
            method: method,
            url: `${configuration.API}/api/${url}`,
            headers: {'content-type': 'application/json'},
            data: data
        });

        return response.data;
    }

    getHistory(page, limit, statut) {
        return this.request('get', `sms?page=${page}&limit=${limit}&statut=${statut || ""}`);
    }

    resend(id) {
        return this.request('post', `sms/${id}/renvoyer`);
    }

    getTemplates() {
        return this.request('get', 'sms-templates');
    }

    saveTemplate(data) {
        return data.id
            ? this.request('put', `sms-templates/${data.id}`, {nom: data.nom, contenu: data.contenu})
            : this.request('post', 'sms-templates', {nom: data.nom, contenu: data.contenu});
    }

    deleteTemplate(id) {
        return this.request('delete', `sms-templates/${id}`);
    }

    preview(data) {
        return this.request('post', 'sms/apercu', data);
    }

    send(data) {
        return this.request('post', 'sms/envoyer', data);
    }
}

/** « il y a 8 secondes », « il y a 3 minutes »... (sans dépendre de la langue de moment). */
export function depuis(secondes) {
    const pluriel = (n, mot) => n + " " + mot + (n > 1 ? "s" : "");
    if (secondes < 5) {
        return "à l'instant";
    }
    if (secondes < 60) {
        return "il y a " + pluriel(Math.floor(secondes), "seconde");
    }
    if (secondes < 3600) {
        return "il y a " + pluriel(Math.floor(secondes / 60), "minute");
    }
    if (secondes < 86400) {
        return "il y a " + pluriel(Math.floor(secondes / 3600), "heure");
    }

    return "il y a " + pluriel(Math.floor(secondes / 86400), "jour");
}
